import apiClient from "../core/HttpClient";
import { TemporaryIllness } from "../models";

export default class TemporaryIllnessService{
    url="/TemporaryIllness";

    public async getTemporaryIllnesses(): Promise<TemporaryIllness[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getTemporaryIllnessById(id: string): Promise<TemporaryIllness> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createTemporaryIllness(model: TemporaryIllness) {
        return await apiClient.post(this.url, model);
    }

    public async updateTemporaryIllness(model: TemporaryIllness) {
        return await apiClient.put(`${this.url}`, model);
    }

    public async deleteTemporaryIllness(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
}
